import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '@/store';
import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(LinearScale, CategoryScale, PointElement, LineElement, Legend, Tooltip, LineController);

//import './index.scss';

type ChartJSModuleProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const ChartJSModule = (componentProps: ChartJSModuleProps) => {
  let props = componentProps;
  let isVisible = true;

  const dataElementContext = React.useContext(DataElementContext);
  [props, isVisible] = processComponentProps(props, dataElementContext);

  const contextValue = React.useMemo(() => {
    return {
      data: {},
      actions: {
        // define callbacks here if needed
      },
      parentContext: dataElementContext,
    };
  }, [dataElementContext]);

  if (!isVisible) {
    return null;
  }

  if (!props.properties?.graph?.type || !props.properties?.graph?.data) {
    return null;
  }

  return (
    <ModuleElementDiv className={props.className ?? ''} $styleText={props.styleText}>
      <DataElementContext.Provider value={contextValue}>
        <Chart
          type={props.properties?.graph?.type}
          data={props.properties?.graph?.data}
          options={props.properties?.graph?.options}
          updateMode={props.properties?.graph?.updateMode ?? 'default'}
        />
        {componentProps.children}
      </DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default ChartJSModule;
